/* Winkelwagen-drawer: USP's uit de upperheader als slider bovenaan de drawer (1 per keer) */
(function () {
	function headerUsps() {
		var seen = {}, usps = [];
		document.querySelectorAll('#nav-top ul.l4us:not(.l4us-mobile) > li').forEach(function (li) {
			var inner = li.querySelector('.inner') || li;
			var text = inner.textContent.trim();
			if (!text || seen[text]) return;
			seen[text] = true;
			usps.push(inner.innerHTML.trim());
		});
		return usps;
	}

	function fillUsps() {
		var list = document.querySelector('#cart .pcd-usps ul');
		if (!list || list.children.length) return;
		headerUsps().forEach(function (html, i) {
			var li = document.createElement('li');
			li.innerHTML = html;
			if (i === 0) li.className = 'is-active';
			list.appendChild(li);
		});
	}

	setInterval(function () {
		var items = document.querySelectorAll('#cart .pcd-usps li');
		if (items.length < 2) return;
		var current = Array.prototype.findIndex.call(items, function (li) { return li.classList.contains('is-active'); });
		if (current < 0) current = 0;
		var next = items[(current + 1) % items.length];
		items.forEach(function (li) { li.classList.remove('is-leaving'); });
		items[current].classList.remove('is-active');
		items[current].classList.add('is-leaving');
		next.style.transition = 'none';
		next.classList.remove('is-leaving');
		next.offsetWidth;
		next.style.transition = '';
		next.classList.add('is-active');
	}, 5000);

	/* Upsell-slider: pijltjes naast de titel */
	function updateUpsellNav(list) {
		var wrap = list.closest('.cart-upsell');
		if (!wrap) return;
		var prev = wrap.querySelector('.pcd-upsell-prev'), next = wrap.querySelector('.pcd-upsell-next');
		var max = list.scrollWidth - list.clientWidth - 2;
		if (prev) prev.disabled = list.scrollLeft <= 2;
		if (next) next.disabled = list.scrollLeft >= max;
	}

	document.addEventListener('click', function (e) {
		var btn = e.target.closest('.pcd-upsell-prev, .pcd-upsell-next');
		if (!btn) return;
		var list = btn.closest('.cart-upsell').querySelector('ul.l4ca');
		var card = list && list.children[0];
		if (!card) return;
		var step = card.getBoundingClientRect().width + 12;
		list.scrollBy({ left: btn.classList.contains('pcd-upsell-prev') ? -step : step, behavior: 'smooth' });
	});

	document.addEventListener('scroll', function (e) {
		if (e.target.matches && e.target.matches('#cart .cart-upsell ul.l4ca')) updateUpsellNav(e.target);
	}, true);

	setInterval(function () {
		var list = document.querySelector('#cart .cart-upsell ul.l4ca');
		if (list) updateUpsellNav(list);
	}, 1000);

	function init() {
		fillUsps();
		var cart = document.getElementById('cart');
		if (cart && window.MutationObserver) new MutationObserver(fillUsps).observe(cart, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();
})();
